import { deviceStatsSchema } from './device-stats.schema';
import { z } from 'zod/v4';

export const deviceStatsLocationDetailsSchema = deviceStatsSchema.extend({
  name: z.string(),
});

export type DeviceStatsLocationDetails = z.infer<
  typeof deviceStatsLocationDetailsSchema
>;
